// src/context/GoogleMapsContext.tsx
import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const GOOGLE_API_KEY = "AIzaSyA_H7WVmlnxy8OWrNuIJmGclYWwXFB49Wk";
const GOOGLE_LIBRARIES: "places"[] = ["places"];

type GoogleMapsContextType = {
	isLoaded: boolean;
	google: typeof google | undefined;
};

const GoogleMapsContext = createContext<GoogleMapsContextType>({
	isLoaded: false,
	google: undefined,
});

export const GoogleMapsProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: GOOGLE_API_KEY,
		libraries: GOOGLE_LIBRARIES,
	});

	return (
		<GoogleMapsContext.Provider
			value={{ isLoaded, google: isLoaded ? google : undefined }}
		>
			{children}
		</GoogleMapsContext.Provider>
	);
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
